import { request } from 'sonata-react-components';

import type { PaginatedType } from 'sonata-static-storage/lib/entities';
import type { Creative } from 'sonata-static-storage/lib/schemas/creative/creative.schema';

export async function getCreativesByUserId(
  userId: string,
  creativeIds: string[],
  token: Record<string, any>
): Promise<PaginatedType<Creative>> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}multiFlight/creative/${userId}`,
    {
      method: 'GET',
      params: {
        ids: creativeIds,
        sortBy: 'date',
        sortOrder: 'desc',
        unlimited: true
      }
    },
    token
  );
}
